module.exports = __webpack_public_path__ + "static/media/invoicePendingRequirementsFirstStep.f7987883.png";